import * as React from 'react';
import * as UploadValidationError from '@utils';

export interface IUploadErrorStateProps {
  errorCode: string;
}

const UploadError: React.FC<IUploadErrorStateProps> = ({ errorCode }) => {
  return (
    <React.Fragment key={errorCode}>
      <hr className='m-0' />
      <div className='py-2 row'>
        <div className='col-3 fcolor--error font-weight-bold'>
          {UploadValidationError.issue(errorCode)}
        </div>
        <div className='col-9'>{UploadValidationError.help(errorCode)}</div>
      </div>
    </React.Fragment>
  );
};

export default UploadError;
